"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressServiceStub = void 0;
class AddressServiceStub {
    async getPostcodeData(postcode) {
        if (postcode) {
            return {
                status: true,
                message: "Postcode data found",
                payload: { postcode: "2122", locality: ["Eastwood, Marsfield"], state: "NSW" },
            };
        }
        return {
            status: true,
            message: "Postcode data not found",
            payload: null,
        };
    }
}
exports.AddressServiceStub = AddressServiceStub;
//# sourceMappingURL=AddressServiceStub.js.map